import { Injectable } from '@angular/core';
import { MyPosService } from '../devices/my-pos/my-pos.service';
import { IAdyenService } from '../devices/adyen/adyen.service';
import { InAppBrowserObject, InAppBrowserOptions, InAppBrowser } from '@core/capacitor-plugins/capacitor-plugins.class';

type TargetType = '_blank' | '_self' | '_system';

/**
 * TODO(legacy-cordova): migrate off `cordova-plugin-inappbrowser`.
 *
 * The plugin is the heaviest remaining Cordova dependency. It has known
 * issues on iOS 17+/18+ (cookie isolation, occasional WebView hangs on
 * dismissal) and is being phased out by Apache. Replacement candidates:
 *  - `@capacitor/browser` for `_system`-style external browser opens (Safari
 *    View Controller / Chrome Custom Tabs). Drop-in for the simple
 *    `openUrl()` path below.
 *  - For the `_blank` flows in `admin-page.service.ts` that listen to
 *    `loadstop` / inject scripts, either embed the page via an `<iframe>` in
 *    a modal, or write a thin Capacitor plugin around `WKWebView`.
 *
 * Keep the current code path until both flows are covered by smoke tests on
 * iOS 18+/26 and Android 14+.
 */
@Injectable({ providedIn: 'root' })
export class InAppBrowserService {
  constructor(private inAppBrowser: InAppBrowser, private myPosService: MyPosService, private adyenService: IAdyenService) {}

  create(url: string, target?: TargetType, options?: string | InAppBrowserOptions): InAppBrowserObject {
    return this.inAppBrowser.create(url, target, options);
  }

  openUrl(url: string, target: TargetType = '_blank') {
    const isMyPOS: boolean = this.myPosService.isTargetDeviceMyPos;
    if (isMyPOS || this.adyenService.isAdyenDevice) {
      this.inAppBrowser.create(url, target);
      return;
    }
    window.open(url, target);
  }
}
